import { Box, Typography } from '@mui/material';
import subscriptionBadgeSrc from '../../assets/profile-drawer/subscription-badge.png';

function SubscriptionBadgeIcon() {
  return (
    <Box sx={{ position: 'relative', width: 32, height: 32, flexShrink: 0, overflow: 'hidden' }}>
      <Box
        component="img"
        src={subscriptionBadgeSrc}
        alt=""
        sx={{
          position: 'absolute',
          height: '99.65%',
          width: '149.34%',
          maxWidth: 'none',
          left: '-24.67%',
          top: '7.64%',
        }}
      />
    </Box>
  );
}

/** Figma 11059:2588 / 11059:2591 — subscription panel */
export default function ProfileSubscriptionPanel({ profile }) {
  if (!profile?.isPremium) return null;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 400,
        height: 52,
        boxSizing: 'border-box',
        borderRadius: '12px',
        border: '0.4px solid #02ca0c',
        bgcolor: '#004102',
        boxShadow: 'inset -2px -2px 15px rgba(0, 0, 0, 0.5)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        px: '10px',
        pt: '10px',
        pb: '10px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px', minHeight: 32 }}>
        <SubscriptionBadgeIcon />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 14,
              lineHeight: '20px',
              letterSpacing: '0.5px',
              color: '#fff',
            }}
          >
            {profile.passTier}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 10,
              lineHeight: '12px',
              color: '#fff',
            }}
          >
            {profile.passEndDate}
          </Typography>
        </Box>
        <Box
          sx={{
            minWidth: 70,
            height: 28,
            borderRadius: '5px',
            border: '0.5px solid #02ca0c',
            bgcolor: '#003005',
            boxShadow: 'inset 0 0 8px rgba(0, 0, 0, 0.55)',
            display: 'grid',
            placeItems: 'center',
            px: 1,
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 12,
              lineHeight: '20px',
              letterSpacing: '0.8px',
              color: '#02ca0c',
            }}
          >
            {profile.passStatus}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
